import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import initialState from '../constants/initialState';
import storageType from '../constants/storageType';
import LocalStorage from '../components/LocalStorage';
import API from '../api/Api';

const globalState = {
    loading: initialState.loading,
    isFetching: initialState.login.isFetching,
    isSuccess: initialState.login.isSuccess,
    isError: initialState.login.isError,
    errorMessage: initialState.login.errorMessage,
    language: initialState.language,
    supportedLangs: initialState.supportedLangs,
    translations: LocalStorage.getValue(storageType.TRANSLATIONS) || {},
    authUser: LocalStorage.getValue(storageType.AUTH_USER) || {}
};

// Translation request from the server
export const translationRequest = createAsyncThunk(
    'application/translations',
    async ({ module_id }, thunkAPI) => {
        try {
            const result = await API.getData('translation/module', { module_id });
            const response = result.data;
            if (response.status) {
                const data = response.data;
                LocalStorage.setValue(storageType.TRANSLATIONS, data);
                return data;
            } else {
                return thunkAPI.rejectWithValue(response);
            }
        } catch (err) {
            return thunkAPI.rejectWithValue({ error: err.message });
        }
    }
);

export const AppReducer = createSlice({
    name: 'application',
    initialState: globalState,
    reducers: {
        clearState(state) {
            Object.assign(state, {
                ...state,
                isFetching: false,
                isSuccess: false,
                isError: false,
                errorMessage: "",
            });
        },
        toggleLoader(state, action) {
            state.loading = action.payload;
        },
        setLanguage(state, action) {
            state.language = action.payload;
            LocalStorage.setValue(storageType.LANGUAGE, action.payload)
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(translationRequest.pending, (state) => {
                state.isFetching = true;
            })
            .addCase(translationRequest.fulfilled, (state, { payload }) => {
                state.isFetching = false;
                state.isSuccess = true;
                state.translations = payload;
            })
            .addCase(translationRequest.rejected, (state, { payload }) => {
                state.isFetching = false;
                state.isError = true;
                state.errorMessage = payload.error || payload.message;
            });
    }
});
export const selectTranslations = (state) => state.global.translations[state.global.language] || {};
export const selectAuthUser = (state) => state.global.authUser;
export const { clearState, toggleLoader, setLanguage } = AppReducer.actions;
export default AppReducer.reducer;